export const locale = {
    lang: 'zh1',
    data: {
      'WIZARD': {
        'TESTTITULO': '嚮導標題：V',
        'CARGANDO': '加載獲取的產品',
        'CARGANDO_PULSOS': '正在加載脈衝',
        'SINPRODS': '您尚未購買此產品',
        'EVALUADOR':{
          'TITUTLO':'評估者'
        },
        'LANDING': {
          'PRODUCTO': {
            'CERTIFICAR':{
              'TITULO': '歡迎認證',
              'CURRENT': '這是您當前的認證過程',
              'FINISHED': '這是完成的認證過程',
              'RESULTS': {
                'CURRENT': '驗證過程未完成',
                // 'FINISHED': '完成認證過程'
                'FINISHED': '這是您當前的認證過程',
                'FINISHED5': '處理結果'
              }
            },
            'Amco':{
              'TITULO': '歡迎來到 AMCO',
               'CURRENT': '這是當前的 amco 進程',
               'FINISHED': '這是一個完整的 amco 過程。',
              'RESULTS': {
                'CURRENT': 'Amco 流程未完成',
                'FINISHED': '這是當前的結果過程',
                'FINISHED5': '結果過程'
              }
            },
            'Trabajo_digno':{
              'TITULO':'歡迎來到第一份工作',
               'CURRENT': '這是當前的第一個就業流程',
               'FINISHED': '這是完成的第一個工作流程。',
              'RESULTS': {
                'CURRENT': '體面的工作流程尚未完成。',
                'FINISHED': '這是當前的結果過程',
                'FINISHED5': '結果過程'
              }
            },
            'Primer_empleo':{
              'TITULO': 'WELCOME TO FIRST JOB',
              'CURRENT': 'This is the current first employment process',
              'FINISHED': 'This is a completed first job process.',
              'RESULTS': {
                'CURRENT': '第一個僱傭程序未完成',
                'FINISHED': '這是當前的結果過程',
                'FINISHED5': '結果過程',
              }
            },

            'CERTIFICAR_C3':{
              'TITULO': '歡迎認證',
              'CURRENT': '這是您當前的認證過程',
              'FINISHED': '這是完成的認證過程',
              'RESULTS': {
                'CURRENT': '驗證過程未完成',
                // 'FINISHED': '完成認證過程'
                'FINISHED': '這是您當前的認證過程',
                'FINISHED5': '處理結果'
              }
            },
            'CERTIFICAR_C4':{
              'TITULO': '歡迎認證銀',
              'CURRENT': '這是您當前的認證過程',
              'FINISHED': '這是完成的認證過程',
              'RESULTS': {
                'CURRENT': '驗證過程未完成',
                // 'FINISHED': '完成認證過程'
                'FINISHED': '這是您當前的認證過程',
                'FINISHED5': '處理結果'
              }
            },
            'MEDIR':{
              'TITULO': '歡迎測量',
              'CURRENT': '這是您當前的測量過程',
              'FINISHED': '這是完成的測量過程',
              'RESULTS': {
                'CURRENT': '測量過程未完成',
                // 'FINISHED': '完成測量過程'
                'FINISHED': '這是您當前的測量過程',
                'FINISHED5': '處理結果'
              }
            },
            'MEDIR_M1':{
              'TITULO': '歡迎增強測量',
              'CURRENT': '這是您當前的測量過程',
              'FINISHED': '這是完成的測量過程',
              'RESULTS': {
                'CURRENT': '測量過程未完成',
                'FINISHED': '完成測量過程',
                'FINISHED5': 'Process results'
              }
            },
            'MEDIR_M2':{
              'TITULO': '歡迎使用測量+ MST',
              'CURRENT': '這是您當前的測量過程',
              'FINISHED': '這是完成的測量過程',
              'RESULTS': {
                'CURRENT': '測量過程未完成',
                'FINISHED': '完成測量過程'
              }
            },
            'MEDIR_M3':{
              'TITULO': '歡迎按地區測量',
              'CURRENT': '這是您當前的測量過程',
              'FINISHED': '這是完成的測量過程',
              'RESULTS': {
                'CURRENT': '測量過程未完成',
                'FINISHED': '完成測量過程'
              }
            },
            'MEDIR_M4':{
              'TITULO': '歡迎領導測量',
              'CURRENT': '這是您當前的測量過程',
              'FINISHED': '這是完成的測量過程',
              'RESULTS': {
                'CURRENT': '測量過程未完成',
                'FINISHED': '完成測量過程'
              }
            },
            'MEDIR_M5':{
              'TITULO': '歡迎按尺寸進行測量',
              'CURRENT': '這是您當前的測量過程',
              'FINISHED': '這是完成的測量過程',
              'RESULTS': {
                'CURRENT': '測量過程未完成',
                'FINISHED': '完成測量過程'
              }
            },
            'MEDIR_M6':{
              'TITULO': '歡迎進行認證',
              'CURRENT': '這是您當前的測量過程',
              'FINISHED': '這是完成的測量過程',
              'RESULTS': {
                'CURRENT': '測量過程未完成',
                'FINISHED': '完成測量過程'
              }
            },
            'PULSE':{
              'TITULO': '歡迎進行脈衝檢查',
              'ADMINTITULO': '行政人員脈搏檢查',
              'PRODU': '脈衝檢查',
              'CURRENT': '這是您當前的脈搏檢查過程',
              'FINISHED': '這是完成的脈衝檢查過程',
              'PULSOS': '這是一個脈衝檢查過程',
              'ENTRAR': '開始',
              'CARGANDO_PULSE':'正在處理加載脈衝檢查',
              'RESULTS': {
                'CURRENT': '脈衝檢查過程未完成',
                // 'FINISHED': '完成脈衝檢查過程'
                'FINISHED': '這是您當前的脈搏檢查過程'
              }
            },
            'FOCUS':{
              'SECTION': '網上論壇管理員',
              'TITLE': '網上論壇管理員',
              'SUBTI': '組的選擇或創建',
              'LAND': {
                'NAME': '調查名稱',
                'INICIO': '開始日期',
                'FIN': '目標日期',
                'AVANCE': '預先',
                'ESTADO': '狀態',
                'COMP': '行為',
                'CREARENC': '創建調查',
                'DELETE': '刪除',
                'EDIT': '編輯',
              },
              'TITULO': '歡迎來到重點領域',
              'CURRENT': '這是您當前的重點領域流程',
              'FINISHED': '這是完成的重點領域過程',
              'RESULTS': {
                'CURRENT': '重點領域流程未完成',
                'FINISHED': '完成重點領域流程'
              }
            },
            'FOCUS_1':{
              'SECTION': '網上論壇管理員',
              'TITLE': '網上論壇管理員',
              'SUBTI': '組的選擇或創建',
              'ADMINTITULO': '行政管理人員重點領域',
              'PRODU': '焦點區域',
              'CARGANDO_FOCUS':'正在加載焦點區域',
              'TAB_PROC_FOC':'重點領域流程',
              'TAB_SUBIDA_COLB_FOC':'合作者上傳',
              'INST_MOD_FILTER_1':'上載您的合作者清單',
              'INST_MOD_FILTER_2':'輸入您選擇的調查',
              'LAND': {
                'NAME': '調查名稱',
                'INICIO': '開始日期',
                'FIN': '目標日期',
                'AVANCE': '預先',
                'ESTADO': '狀態',
                'COMP': '行為',
                'CREARENC': '創建調查',
                'DELETE': '刪除',
                'EDIT': '編輯',
              },
              'TITULO': '歡迎來到重點領域',
              'CURRENT': '這是您當前的重點領域流程',
              'FINISHED': '這是完成的重點領域過程',
              'RESULTS': {
                'CURRENT': '重點領域流程未完成',
                'FINISHED': '完成重點領域流程'
              }
            },
            'MEDIR_M9':{
              'TITULO': '歡迎參加 INNMOTION 調查',
              'CURRENT': '這是您當前的重點領域流程',
              'FINISHED': '這是完成的重點領域過程',
              'RESULTS': {
                'CURRENT': '重點領域流程未完成',
                'FINISHED': '完成重點領域流程'
              }
            },
          },
          'DONE': '申請年份 ',
          'LEGA': '舊版結果',
          'FOCUS': '調查到重點區域',
          'ENTRAR': '申請年份',
          'IR':'進入',
          ////instituto turquia///
          'INST-TURQUEY':{
            'TITULO':'文化簡介文化審核5.0',
            'TITULO-1':'文化簡介文化審核5.0',
            'TITULO1':'文化簡介文化審核5.0',
            'TITULO2':'文化簡介5.0',
            'TITULO3':'文化審核5.0',
            'TITULO4':'特別清單',


          },
          'INST-ESP':{
            'TITULO':'文化審核 ',
            'TITULO1':'文化審核 ',
            'TITULO2':'文化審核  5.0',
            'TITULO3':'行动计划',
          },
          'INST-CHINA':{
            'TITULO':'文化審核',
            'TITULO1':'文化審核',
            'TITULO2':'文化評估 5.0',
            'TITULO3':'文化審核 SP',
            'TITULO4':'文化評估 5.0',
            'TITULO5':'4ALL 文化評估',
          }
          },
          'STEPSTAT': {
            'LOCK': '鎖步',
            'PEND': '步開',
            'COMP': '步驟完成'
          },

        'NOPRODUCTS': {
          'TITULO': '貴公司沒有已購入產品',
          'SUBTI': '報價資料'
        },
        'GUIA35': {
          'TITULO': '指南NOM-035-STPS-2018',
          'SUBTITULO':'描述',
          'DESCRIPCION': '關於NOM-035-STPS-2018的信息',
          'ENTRAR': '開始'

        },
        'ENCUESTA35': {
          'TITULO': '投票機NOM-035-STPS-2018',
          'SUBTITULO':'描述',
          'DESCRIPCION': '以下部分屬於NOM-035-STPS-2018的調查員，在調查員中，將確定工人組織環境中的不同社會心理風險因素',
          'ENTRAR': '開始'
        },
        'Amco': {
          'TITULO': '安科',
        },
        'Trabajo_digno':{
             'TITULO': '體面的工作',
           },
           'Primer_empleo':{
             'TITULO': '第一份工作',
           },
           'NOM35V3': {
               'TITULO': '標準 035 3.0'
           },
           'CERTIFICAR_C4': {
               'TITULO': '銀證'
           },
        'CERTIFICAR': {
          'TITULO': '證明',
          'STEPS': {
            'STP1': {
              'WIZBT': '語言能力',
              'TITULO': '語言能力',
              'SUBTI': '語言選擇'
            },
            'STP_NPS': {
              'WIZBT': 'NPS',
              'TITULO': 'NPS',
              'SUBTI': 'NPS版'
            },
            'STP1-1': {
              'WIZBT': '試劑種類',
              'TITULO': '試劑種類',
              'SUBTI': '試劑選擇'
            },
            'STP1-FOCUS-PLANTILLA': {
              'WIZBT': '範本',
              'TITULO': '範本',
              'SUBTI': '試劑選擇'
            },
            ////idioma chino tradicional 4ALL practice
            'STP2': {
              'WIZBT': '4ALL 實踐',
              'TITULO': '4ALL 實踐',
              'SUBTI': '於貴公司的調研加入4ALL實踐'
            },
            'STP_CONTROL': {
              'WIZBT': '控制問題',
              'TITULO': '控制問題',
              'SUBTI': '編輯控制問題'
            },
            'STP3': {
              'WIZBT': '人口統計資料',
              'TITULO': '人口統計資料',
              'SUBTI': '插入要在調研中顯示的人口統計信息. 注意：黃色的受眾特徵是可選的'
            },
            'STP3-1': {
              'WIZBT': '公開問題',
              'TITULO': '公開問題',
              'SUBTI': '輸入未解決的問題'
            },
            'STP4': {
              'WIZBT': '附加項',
              'TITULO': '附加項',
              'SUBTI': '在調查新增其他問題'
            },
            'STP4-FOCUS-PLANTILLA': {
              'WIZBT': '個性化',
              'TITULO': '個性化',
              'SUBTI': '在調查新增其他問題'
            },
            'STP4-1': {
              'WIZBT':	'生成调查',
              'TITULO':	'生成调查',
              'SUBTI':	'生成调查',
              'WIZBT2':	'生成调查',
              'TITULO2':	'生成调查',
            },
            'STP5': {
              'WIZBT': '員工',
              'TITULO': '員工',
              'SUBTI': '上載員工資料庫'
            },
            'STP6': {
              'WIZBT': '編排調研',
              'TITULO': '編排調研',
              'SUBTI': '安排調研的開始和發送提醒電郵的日期'
            },
            'STP7': {
              'WIZBT': '郵件發送',
              'TITULO': '郵件發送',
              'SUBTI': '將調研邀請發送給您的員工'
            },
            // 'STP8': {
            //   'WIZBT': '調查結束',
            //   'TITULO': '調查結束',
            //   'SUBTI': '調查結束前的進展'
            // },
            'STP8': {
              'WIZBT': '調查跟進',
              'TITULO': '調查跟進',
              'SUBTI': '調查結束前的進展'
            },
            'STP9': {
              'WIZBT': '激活調查',
              'TITULO': '激活調查',
              'SUBTI': '激活調查'
            },
            'STP10': {
              'WIZBT': '模板',
              'TITULO': '對模板進行修改',
              'SUBTI': '模板'
            },
            'STP_VOICE': {
              'WIZBT': '語音設置',
              'TITULO': '為帶有音頻的調查設置語音設置',
              'SUBTI': '為帶有音頻的調查設置語音設置'
            }
          }
        },
        'CERTIFICARAMCO': {
          'TITULO': '安科',
        },
        'CERTIFICARTRABADIG': {
          'TITULO': '體面的工作',
        },
        'CERTIFICARADICPRIEMPL': {
          'TITULO': '第一份工作',
        },
        'CERTIFICAR35': {
          'TITULO': 'NOM-035-STPS-2018',
          'LANDING': {
            'TITULO': '歡迎來到NOM-035-STPS-2018',
            'DONE': '申請年份',
            'ENTRAR': '開始'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': '語言能力',
              'TITULO': '語言能力',
              'SUBTI': '語言選擇'
            },
            'STP2': {
              'WIZBT': '4ALL實踐',
              'TITULO': '4ALL實踐',
              'SUBTI': '插入貴公司的4ALL做法進行調查'
            },
            'STP3': {
              'WIZBT': '客層',
              'TITULO': '客層',
              'SUBTI': '插入要在調查中顯示的人口統計信息'
            },
            'STP4': {
              'WIZBT': '附加項',
              'TITULO': '附加項',
              'SUBTI': '為調查插入其他問題'
            },
            'STP5': {
              'WIZBT': '合作者',
              'TITULO': '合作者',
              'SUBTI': '上載公司合作者數據庫'
            },
            'STP6': {
              'WIZBT': '時間表調查',
              'TITULO': '時間表調查',
              'SUBTI': '安排調查的發布和提醒日期'
            },
            'STP7': {
              'WIZBT': '郵件發送',
              'TITULO': '郵件發送',
              'SUBTI': '將調查邀請發送給您的合作者'
            },
            'STP8': {
              'WIZBT': '調查結束',
              'TITULO': '調查結束',
              'SUBTI': '調查結束前的進展'
            },'STP9':{
              'WIZBT': '溝通計劃',
              'TITULO': '溝通計劃',
              'SUBTI': '將調查邀請發送給您的合作者'
            },'STP10':{
              'WIZBT': '合作者',
              'TITULO':'合作者',
              'SUBTI': '為NOM035調查做好準備'
            }
          }
        },
        'PULSE': {
          'TITULO': '脈衝檢查',
          'LANDING': {
            'TITULO': '歡迎進行脈衝檢查',
            'DONE': '申請年份 ',
            'ENTRAR': '開始'
          },
            'STEPS': {
              // 'STP1': {
              //   'WIZBT': '語言能力',
              //   'TITULO': '語言能力',
              //   'SUBTI': '語言選擇'
              // },
              // 'STP1-1': {
              //   'WIZBT': '試劑種類',
              //   'TITULO': '試劑種類',
              //   'SUBTI': '試劑選擇'
              // },
              // ////idioma chino tradicional 4ALL practice
              // 'STP2': {
              //   'WIZBT': '4ALL 實踐',
              //   'TITULO': '4ALL 實踐',
              //   'SUBTI': '於貴公司的調研加入4ALL實踐'
              // },
              // 'STP3': {
              //   'WIZBT': '人口統計資料',
              //   'TITULO': '人口統計資料',
              //   'SUBTI': '插入要在調研中顯示的人口統計信息'
              // },
              // 'STP3-1': {
              //   'WIZBT': '公開問題',
              //   'TITULO': '公開問題',
              //   'SUBTI': '輸入未解決的問題'
              // },
              // 'STP4': {
              //   'WIZBT': '附加項',
              //   'TITULO': '附加項',
              //   'SUBTI': '在調查新增其他問題'
              // },
              // 'STP5': {
              //   'WIZBT': '員工',
              //   'TITULO': '員工',
              //   'SUBTI': '上載員工資料庫'
              // },
              'STP6': {
                'WIZBT': '編排調研',
                'TITULO': '編排調研',
                'SUBTI': '計劃調查日期脈衝檢查'
              },
              'STP7': {
                'WIZBT': '郵件發送',
                'TITULO': '郵件發送',
                'SUBTI': '將調研邀請發送給您的員工'
              },
              'STP8': {
                'WIZBT': '調查進度',
                'TITULO': '調查進度',
                'SUBTI': '檢查測量進度脈衝檢查'
              }
            }
          },
        'MEDIR': {
          'TITULO': '測量',
          'LANDING': {
            'TITULO': '歡迎測量',
            'DONE': '申請年份 ',
            'ENTRAR': '開始'
          }
        },
        'MEDIR_M1': {
          'TITULO': '增強測量',
          'LANDING': {
            'TITULO': '歡迎增強測量',
            'DONE': '申請年份 ',
            'ENTRAR': '開始'
          }
        },
        'MEDIR_M2': {
          'TITULO': '測量+ MST',
          'LANDING': {
            'TITULO': '歡迎使用測量+ MST',
            'DONE': '申請年份 ',
            'ENTRAR': '開始'
          }
        },
        'MEDIR_M3': {
          'TITULO': '按區域測量',
          'LANDING': {
            'TITULO': '歡迎按地區測量',
            'DONE': '申請年份 ',
            'ENTRAR': '開始'
          }
        },
        'MEDIR_M4': {
          'TITULO': '領導測量',
          'LANDING': {
            'TITULO': '歡迎領導測量',
            'DONE': '申請年份 ',
            'ENTRAR': '開始'
          }
        },
        'MEDIR_M5': {
          'TITULO': '按尺寸測量',
          'LANDING': {
            'TITULO': '歡迎按尺寸進行測量',
            'DONE': '申請年份 ',
            'ENTRAR': '開始'
          }
        },
        'MEDIR_M6': {
          'TITULO': '認證措施',
          'LANDING': {
            'TITULO': '歡迎進行認證',
            'DONE': '申請年份 ',
            'ENTRAR': '開始'
          }
        },
        'MEDIR_M9': {
          'TITULO': '動感調查',
          'LANDING': {
            'TITULO': '歡迎參加 INNMOTION 調查',
            'DONE': '申請年份 ',
            'ENTRAR': '開始'
          }
        },
        'FOCUS':{
          'TITULO': '重點地區',
          'LANDING': {
            'TITULO': '歡迎來到重點領域',
            'DONE': '申請年份 ',
            'ENTRAR': '開始'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': '語言能力',
              'TITULO': '語言能力',
              'SUBTI': '語言選擇'
            },
            'STP2': {
              'WIZBT': '管理群組',
              'TITULO': '管理群組',
              'SUBTI': '插入貴公司的4ALL做法進行調查'
            },
            'STP3': {
              'WIZBT': '管理調查',
              'TITULO': '管理調查',
              'SUBTI': '插入要在調查中顯示的人口統計信息'
            },
            'STP4': {
              'WIZBT': '調查委員會',
              'TITULO': '調查委員會',
              'SUBTI': '為調查插入其他問題'
            }
          }
        },
        'LEADER_GO':{
          'TITULO_ADMIN': 'LEADER GO® 歡迎管理員',
          'TITULO': 'LEADER GO® 歡迎光臨',
          'TITULO_PRODUCT':'Leader Go® 管理員',
          'TITULO_PRODUCT2':'Leader Go®',
          'LANDING': {
            'TITULO': '歡迎來到LEADER GO',
            'DONE': '申請年份：',
            'ENTRAR': '開始'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': '語言',
              'TITULO': '語言',
              'SUBTI': '語言選擇'
            },
            'STP2': {
              'WIZBT': '領袖選擇',
               'TITULO': '領袖選擇',
               'SUBTI': '選擇領導者',
            },
            'STP3': {
              'WIZBT': '通訊訊息',
               'TITULO': '通訊訊息',
               'SUBTI': '登錄編輯郵件',
            },
            'STP4': {
              'WIZBT': '確認',
               'TITULO': '確認',
               'SUBTI': '輸入以確認發送電子郵件',
            },
            'STP5': {
              'WIZBT': '前進',
                 'TITULO': '前進',
                 'SUBTI': '前進',
            }
          }

        },
        'ACTION_GO':{
          'TITULO_ADMIN': 'ACTION GO® 歡迎管理員',
           'TITULO': 'ACTION GO® 歡迎',
           'TITULO_PRODUCT':'Action GO® 管理員',
           'TITULO_PRODUCT2':'Action GO®',
        },
        'LANDING_REQUERIMIENTOSV3':{
            'TITULO':'技術要求',
            'EXTERNAL_PORTAL': '複製外部RT網址',
            'COPYA_MESSAGE':'網址已復製到剪貼板',

        },
        'GOFLOW':{
          'TITULO': '結果 GoFlow',
        },
      },
    }
};
